module.exports = __webpack_public_path__ + "ath_game_web/img/7.3.baefcf56.png";